/**
 * Константы полов: подписи укладок и значения по умолчанию.
 * Сами покрытия — в каталоге (`floorSection`), здесь их больше не дублируем.
 */
import { FloorLayout, FloorMaterial, type FloorLayoutInfo } from "./types";

export const FLOOR_LAYOUTS: FloorLayoutInfo[] = [
	{ id: FloorLayout.Tile, label: "Прямая укладка" },
	{ id: FloorLayout.Straight, label: "Палубная укладка (шаг 1/2)" },
	{ id: FloorLayout.Half, label: "Палубная укладка (шаг 1/3)" },
	{ id: FloorLayout.Third, label: "Палубная укладка (шаг 1/4)" },
	{ id: FloorLayout.FrenchHerringbone, label: "Французская ёлка" },
	{ id: FloorLayout.EnglishHerringbone, label: "Английская ёлка" },
];

export const DEFAULT_FLOOR_MATERIAL: FloorMaterial = FloorMaterial.Tile;
export const DEFAULT_FLOOR_LAYOUT: FloorLayout = FloorLayout.Tile;
